import React from 'react';
import { LogOut } from './LogOut';
import { IApiEmployee, IBosApiDealerInfoData } from 'next-common';
import { useReactiveVar } from '@apollo/client';
import { selectedDealerId, useDealer } from '../../../../../common';
import { Icon, IconType } from '@repo/ui/components';

export interface ISettingsFooterProps {
  employee: IApiEmployee;
}

const SettingFooterInfo = (props) => (
  <div className="grid grid-cols-[1rem_auto] gap-x-[5px] h-4.5 items-center">
    <div className="flex place-items-center">
      <Icon
        icon={props.icon}
        aria-hidden
        fill="var(--color-oldSilver)"
        width={16}
        height={16}
        viewBox={props?.icon === 'user' ? '0 0 48 48' : '0 0 24 24'}
      />
    </div>
    <div className="text-xs font-normal overflow-hidden truncate">{props.text}</div>
  </div>
);

const formatDealerName = (dealer: IBosApiDealerInfoData) => {
  if (!dealer) return 'Ukjent forhandler';
  return dealer.name.replace(/bertel o\.? steen/gi, 'BOS');
};

export const SettingsFooter = (props: ISettingsFooterProps) => {
  const employeeIdent = props.employee?.employeeId;
  const employeeEmail = props.employee?.email;

  const dealerId = useReactiveVar<string>(selectedDealerId);
  const { dealer }: { dealer: IBosApiDealerInfoData } = useDealer({ dealerId });

  return (
    <div className="py-3 px-5 border-t border-silverSand">
      <SettingFooterInfo icon={IconType.NewNextEMail} text={employeeEmail?.toLowerCase()} />
      <SettingFooterInfo icon={IconType.NewNextUser} text={employeeIdent?.toLowerCase() ?? 'Ukjent ident'} />
      <SettingFooterInfo icon={IconType.Shop} text={formatDealerName(dealer)} />
      <div className="text-base/[175%] mt-4">
        <LogOut />
      </div>
    </div>
  );
};
